<template>
  <div class="app-container">
    <keep-alive>
      <item :columnData="columnData" :is-activated="isActivated" :routeName="routeName" :menuName="menuName" :titleName="titleName" :parent="parent" :tab="tab"></item>
    </keep-alive>
  </div>
</template>
<script>
import Item from './components/Item'
let isPageActivated = false
export default {
  name: 'afterSales',
  components: {Item},
  data () {
    return {
      isActivated: false,
      parent: 'afterSales',
      columnData: [{
        type: 'selection',
        width: '40',
        fixed: 'left'
      }, {
        field: 'operate',
        title: '操作',
        width: '170',
        fixed: 'left',
        isDefine: true,
        child: [{
          className: 'btn-16-bd-85 btn-hover mr-5',
          title: '详情',
          methodName: 'on-detail',
          type: 'btn'
        }, {
          type: 'btn',
          className: 'btn-16-bg-85 btn-hover mr-5',
          title: '管理',
          methodName: 'on-manage'
        }, {
          type: 'btn',
          className: 'btn-16-bd-85 btn-hover',
          title: '消息',
          methodName: 'on-message'
        }]
      }, {
        type: 'index',
        title: '序号',
        width: '60',
        fixed: 'left'
      }, {
        field: 'businessStatus',
        title: '业务状态',
        width: '120'
      }, {
        field: 'financeStatusStr',
        title: '财务状态',
        width: '100'
      }, {
        field: 'lastLog',
        title: '客户日志',
        width: '200'
      }, {
        field: 'photoStatusStr',
        title: '效果图',
        width: '200'
      }, {
        field: 'customerNumber',
        title: '客户编号',
        width: '140'
      }, {
        field: 'name',
        title: '客户名字',
        width: '80'
      }, {
        field: 'telephone',
        title: '客户电话',
        width: '100'
      }, {
        field: 'detailedAddress',
        title: '装修地点',
        width: '250'
      }, {
        field: 'afterSalesNumber',
        title: '售后服务号',
        width: '150'
      }, {
        field: 'customerAssign.asName',
        title: '售后人员',
        width: '80'
      }, {
        field: 'customerAssign.salesmanName',
        title: '业务员',
        width: '80'
      }, {
        field: 'customerAssign.salesmanDepartmentName',
        title: '业务部',
        width: '100'
      }, {
        field: 'customerAssign.cmName',
        title: '客户经理',
        width: '80'
      }, {
        field: 'customerAssign.cmDepartmentName',
        title: '客服部',
        width: '100'
      }, {
        field: 'customerAssign.designerName',
        title: '设计师',
        width: '80'
      }, {
        field: 'customerAssign.designerDepartmentName',
        title: '设计部',
        width: '100'
      }, {
        field: 'afterSalesStartTime',
        title: '售后开始时间',
        width: '200',
        formatter: ['toDateString', 'yyyy-MM-dd']
      }],
      routeName: '',
      menuName: '',
      titleName: '',
      tab: [{
        name: '我的售后服务',
        nickName: 'submitAs',
        timeName: '售后',
        startTName: 'asStartTime',
        endTName: 'asEndTime',
        type: 1
      }]
    }
  },
  created () {
    this.routeName = this.$route.name
    this.menuName = this.$route.meta.nickName
    this.titleName = this.$route.meta.title
  },
  beforeRouteEnter (to, from, next) {
    if (from.meta) {
      /**
       * isActivated: true --> 后退而来
       * isActivated：false --> 其他页面跳转来
       */
      isPageActivated = from.meta.isActivated || false
    }
    next()
  },
  activated () {
    this.isActivated = isPageActivated
  },
  beforeRouteLeave (to, from, next) {
    if (!to.meta.isAlone) {
      this.isActivated = false
    }
    next()
  },
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/customer/afterSales.vue